import React, { useState, useEffect } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Input } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { API_URLS } from "../../../../../api/apiUrls";
import { putApi } from "../../../../../api/api_instance";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../../../components/Elements/DialogBox/AcceptDialog";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const EditLocation = ({
  onOpen,
  onClose,
  locationData,
  onUpdate,
  onSuccess,
}) => {
  const [location_name, setlocation_name] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const [errorMessage, setErrorMessage] = useState({
    description: "",
    setDescription: "",
  });

  useEffect(() => {
    if (locationData) {
      setlocation_name(locationData.location_name || "");
      setDescription(locationData.description || "");
    }
  }, [locationData]);

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { location_name: "", description: "" };

    if (!location_name) {
      errors.location_name = "Location is required";
      isValid = false;
    }
    if (!description) {
      errors.description = "description is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);

    try {
      const response = await putApi({
        apiUrl: API_URLS.EDIT_LOCATIONUSER(locationData._id),
        data: { location_name, description },
      });

      if (response.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Location User added successfully.
        //       </h2>
        //     </div>
        //   ),
        // });

        triggerPopup("success", "Success", " Location User Edit successfully.");

        // setTimeout(() => {
        //   Modal.destroyAll();
        //   onClose();
        // }, 2000);
        setTimeout(() => {
          Modal.destroyAll();
          if (onUpdate) onUpdate();
          onClose();
        }, 2000);
      } else {
        //toast.error(response.message || "Update failed.");
        triggerPopup(
          "error",
          "Add User Failed",
          response.message || "Update failed",
        );
      }
    } catch (error) {
      //toast.error(error.message || "Something went wrong.");
      triggerPopup(
        "error",
        "Add User Failed",
        error.message || "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="600px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Edit Location</h3>
        </div>
        <div className="rounded-xl border mt-8 px-12">
          <div className="mt-3 mb-4">
            <hr />
          </div>
          <div className="flex flex-col gap-6">
            <Input
              value={location_name}
              onChange={(e) => setlocation_name(e.target.value)}
              placeholder="Location Name"
              className="h-14 rounded-lg"
            />
            {errorMessage.location_name && (
              <div className="text-red-500 text-sm">
                {errorMessage.location_name}
              </div>
            )}

            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              className="h-14 rounded-lg"
            />
            {errorMessage.description && (
              <div className="text-red-500 text-sm">
                {errorMessage.description}
              </div>
            )}
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={onClose}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </DialogBox>

      {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={() => {
            setShowAcceptDialog(false);
            onClose();
          }}
          heading="Location Updated"
          subheading="Location have been successfully updated."
          success={true}
        />
      )}
    </>
  );
};

export default EditLocation;
